// extracted by mini-css-extract-plugin
export default {"container":"container-jBr4i","warning":"warning-iv3Av"};